const ALLOWED_FILE_FORMATS = ['jpg', 'png', 'jpeg']

export { ALLOWED_FILE_FORMATS }
export default ALLOWED_FILE_FORMATS
